import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { NavLink, useLocation } from 'react-router-dom';
import Logo from '../Assets/light-logo.png';
import SvgOrderActive from '@design-system/Assets/OrderActive';
import { getUser } from '@app/auth/redux/selectors';
import { useSelector } from 'react-redux';
import SvgOrder from '@design-system/Assets/Order';
import CreditCard from '@design-system/Assets/CreditCard';
import CreditCardActive from '@design-system/Assets/CreditCardActive';
import SvgHelp from '@design-system/Assets/Help';
import SvgLogo from '@design-system/Assets/Logo';
import SvgRecipe from '@design-system/Assets/RecipePlay';
import recipeDark from '@design-system/Assets/recipe-play.png';
import SvgBasketActive from '@design-system/Assets/BasketActive';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';
import clsx from 'clsx';
import { Text } from '@design-system/Text';
import SvgDashboardIcon from '@design-system/Assets/SvgDashboardIcon';
import SvgBasketIcon from '@design-system/Assets/SvgBasketIcon';
import { getProfileDetails } from '@app/profile/redux/selectors';

const SidePaneStyle = styled.main`
  background-color: '#fff';
  grid-area: sideMenu;
  display: flex;
  color: ${(props) => (props.color ? props.color : '#fff')};
  border: ${(props) => (props.border ? props.border : 'none')};
  width: 100%;

  ${mediaQuery.desktop`
  flex-direction: column;
  display: block;
  position: fixed;
  width: 13rem;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  padding: 1rem;
  height: 100vh;
  `}

  .ak-logo {
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    width: 100%;

    ${mediaQuery.desktop`
    justify-content: center;
    width: 100%;
  margin-bottom: 3rem;
    `}

    > img {
      /* hack */
      display: block;
      ${mediaQuery.desktop`
      display: block;
      margin-bottom: 3rem;
      width: 10rem;
      margin-right: 0;


  `}
    }
  }

  .web-routes {
    display: none;
    ${mediaQuery.desktop`

display: block;
  `}
  }
  ul {
    list-style-type: none;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
  }
  a {
    text-decoration: none;
    transition: 0.2s ease-in all;
    cursor: pointer;
    color: #797b80;
    padding: 1rem;
    display: flex;
    border-radius: none;
    margin-top: 2rem;
    text-transform: capitalize;
  }

  .route-logo {
    margin-right: 1rem;
  }

  .item-link {
    display: flex;
    align-content: center;
    align-items: center;
    color: #797b80;
    text-decoration: none;
    /* height: 2rem; */
    padding: 1rem;
    border-radius: 1rem;
    margin-top: 2rem;

    &:hover {
      color: white;
      background-color: #549a9a;
    }
  }
  .item-link-selected {
    color: #ffffff;
    background-color: #549a9a;
  }

  .item-links {
    color: #000;
    text-transform: capitalize;
    border-bottom: 1px solid #c4c4c426;
    border-radius: none;
    font-weight: 500;
  }

  .item-links-active {
    color: #549a9a;
  }

  .link-logo {
    width: 1rem;
    margin-right: 1rem;
    margin-top: 5px;
    posittion: relative;
  }

  .footer {
    width: 80%;
    position: absolute;
    bottom: 0;
    margin-bottom: 3rem;
  }
  .mobile-nav {
    margin-top: -10rem;
  }

  .user {
    padding: 1rem;
    position: relative;
    border-bottom: 1px solid #549a9a;
    width: 92vw;
  }

  .user-box {
    display: flex;
    align-content: center;
    align-items: center;
  }

  .user-img {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background: #acd1d1;
    margin-right: 1rem;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    color: #000;
    font-weight: 700;
  }

  .profile_image{
     width: 50px;
    height: 50px;
    border-radius: 100%;
    object-fit:cover
    margin-right:5px
  }
`;

const StyledHeader = styled.header`
  position: fixed;
  background: #fff;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 5;

  ${mediaQuery.desktop`
display: none;
    `}

  .menu {
    height: 40px;
    width: 40px;
  }

  .hamburger {
    z-index: 6;

    cursor: pointer;
    height: 2.5rem;
    width: 1.7rem;
    position: relative;
    padding: 1px;
    margin: 1rem;

    .bar {
      position: absolute;
      width: 1.7rem;
      height: 3px;
      background-color: #549a9a;
      top: 50%;
      transition: 0.3s ease-in-out;
      border-radius: 5px;

      &:nth-child(1) {
        transform: translateY(-6px);
      }

      &:nth-child(2) {
        transform: translateY(6px);
      }
    }

    ${mediaQuery.desktop`
      display: none;
    `}

    &.open {
      .bar {
        &:nth-child(1) {
          transform: translateY(0) rotate(45deg);
        }
        &:nth-child(2) {
          transform: translateY(0) rotate(-45deg);
        }
      }
    }
  }
`;

const StyledMobileNav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  display: flex;
  background: #fff;
  z-index: 6;

  .hamburger {
    z-index: 6;
    cursor: pointer;
    height: 2.5rem;
    width: 1.7rem;
    position: relative;
    left: 85%;

    .bar {
      position: absolute;
      width: 1.7rem;
      height: 2px;
      border: 2px solid #549a9a;
      top: 50%;
      transition: 0.3s ease-in-out;

      &:nth-child(1) {
        transform: translateY(-4px);
      }

      &:nth-child(2) {
        transform: translateY(4px);
      }
    }

    ${mediaQuery.desktop`
      display: none;
    `}

    &.open {
      .bar {
        &:nth-child(1) {
          transform: translateY(0) rotate(45deg);
        }
        &:nth-child(2) {
          transform: translateY(0) rotate(-45deg);
        }
      }
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;

    a {
      text-transform: uppercase;
      letter-spacing: 0.8px;
      transition: 0.3s ease-in-out;
    }

    > * + * {
      margin-top: 12px;
    }
  }
`;

const HoverIcon = styled.div`
  &:hover {
    path {
      fill: #fff;
      stroke: #fff;
    }
    rect {
      stroke: #fff;
    }
  }
`;

const SidePane = () => {
  const user = useSelector(getUser);
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const profile = useSelector(getProfileDetails);
  const location = useLocation();
  const handleEsc = (e) => {
    if (e.key === 'Escape') setHamburgerOpen(false);
  };
  useEffect(() => {
    if (hamburgerOpen) {
      window.addEventListener('keydown', handleEsc);
    } else {
      window.removeEventListener('keydown', handleEsc);
    }
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [hamburgerOpen]);

  const handleHamburger = () => {
    setHamburgerOpen(!hamburgerOpen);
  };

  const hamburgerClassNames = clsx({
    hamburger: true,
    open: hamburgerOpen,
  });

  const mobileNavRoutes = [
    {
      title: 'Products',
      to: `/products`,
    },
    {
      title: 'Baskets',
      to: `/baskets`,
    },
    {
      title: 'Recipes',
      to: `/recipes`,
    },
    {
      title: 'Invitations',
      to: `/invitations`,
    },
    {
      title: 'Payments',
      to: `/payments`,
    },
    {
      title: 'Previous Orders',
      to: `/order-history`,
    },
    {
      title: 'Help',
      to: `/help`,
    },
  ];

  const sideNavRoutes = [
    {
      title: 'Products',
      to: `/products`,
      icon: <SvgDashboardIcon color="#828282" />,
      iconActive: <SvgDashboardIcon color="#fff" />,
    },
    {
      title: 'Baskets',
      to: `/baskets`,
      icon: <SvgBasketIcon color="#828282" />,
      iconActive: <SvgBasketActive />,
    },
    {
      title: 'Recipes',
      to: `/recipes`,
      icon: <img src={recipeDark} alt={recipeDark} />,
      iconActive: <SvgRecipe />,
    },
    {
      title: 'Previous Orders',
      to: `/order-history`,
      icon: <SvgOrder color="#828282" />,
      iconActive: <SvgOrderActive />,
    },
    {
      title: 'Payments',
      to: `/payments`,
      icon: <CreditCard color="#828282" />,
      iconActive: <CreditCardActive />,
    },
    {
      title: 'Help',
      to: `/help`,
      icon: <SvgHelp />,
      iconActive: <SvgHelp color="#fff" />,
    },
  ];
  return (
    <SidePaneStyle>
      <img src={Logo} alt="akani-logo" />
      <StyledHeader>
        <div className="ak-logo">
          {/* <img src={Logo} alt="akani-logo" /> */}
          <div>
            <SvgLogo style={{ marginLeft: '15px' }} />
          </div>

          <div className={hamburgerClassNames} onClick={handleHamburger}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>
      </StyledHeader>
      {hamburgerOpen && (
        <>
          <StyledMobileNav>
            <ul className="mobile-nav">
              <div className="user">
                <div className={hamburgerClassNames} onClick={handleHamburger}>
                  <span className="bar"></span>
                  <span className="bar"></span>
                </div>
                <div className="user-box">
                  {profile.photo_url ? (
                    <img
                      src={profile.photo_url}
                      alt="profile"
                      className="profile_image"
                    />
                  ) : (
                    <div className="user-img">
                      {user.first_name.charAt(0)}
                      {user.last_name.charAt(0)}
                    </div>
                  )}

                  <div>
                    <Text align="left" size="small" weight="600">
                      {user.first_name} {user.last_name}
                    </Text>
                    <Text color="#828282" align="left" size="small">
                      {user.email}
                    </Text>
                  </div>
                </div>
              </div>
              <div className="line" />
              {mobileNavRoutes.map((route) => (
                // eslint-disable-next-line react/jsx-indent-props
                <NavLink
                  key={route.title}
                  to={route.to}
                  className="item-links"
                  activeClassName="item-links-active"
                >
                  {route.title}
                </NavLink>
              ))}
              <NavLink
                to={'/logout'}
                className="item-links"
                activeClassName="item-links-active"
              >
                Log Out
              </NavLink>
            </ul>
          </StyledMobileNav>
        </>
      )}

      <ul className="web-routes">
        {sideNavRoutes.map((route) => (
          // eslint-disable-next-line react/jsx-indent-props
          <HoverIcon key={route.title}>
            <NavLink
              to={route.to}
              className="item-link"
              activeClassName="item-link-selected"
            >
              <div className="link-logo">
                {route.to === location.pathname
                  ? route.iconActive
                  : route.to.includes(location.pathname.split('/')[1])
                  ? route.iconActive
                  : route.icon}
              </div>
              {route.title}
            </NavLink>
          </HoverIcon>
        ))}
      </ul>
    </SidePaneStyle>
  );
};

export default SidePane;

// SidePane.propTypes = {
//   userId: PropTypes.string.isRequired,
// };
